import { MenuItem, Select } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const ActiveInactive = ({ getData, setStatus, status, width, setPage }) => {
  const options = [
    { id: 1, value: "Active", realValue: 1 },
    { id: 2, value: "Inactive", realValue: 0 },
    { id: 3, value: "All", realValue: -1 },
  ];

  const [selectedValue, setSelectedValue] = useState("");

  useEffect(() => {
    if (selectedValue) {
      getData(1);
      setPage(1);
    }
  }, [status]);

  return (
    <Select
      style={{ width: width || "50%", height: "40px", marginRight: "10px" }}
      required
      displayEmpty
      renderValue={selectedValue !== "" ? undefined : () => "Select Status"}
      value={selectedValue}
      onChange={(e) => {
        if (e.target.value === 1) {
          setStatus(1);
        } else if (e.target.value === 2) {
          setStatus(0);
        } else {
          setStatus("");
        }

        setSelectedValue(e.target.value);
      }}
    >
      {options.map((item, index) => (
        <MenuItem key={index + ""} value={item.id}>
          {item.value}
        </MenuItem>
      ))}
    </Select>
  );
};

// ✅ Add PropTypes validation
ActiveInactive.propTypes = {
  getData: PropTypes.any,
  setStatus: PropTypes.any,
  status: PropTypes.any,
  width: PropTypes.string,
  setPage: PropTypes.any,
};

export default ActiveInactive;
